// extracted by mini-css-extract-plugin
export var selectContent = "Select-module--selectContent--57e19";
export var selectIconColor = "Select-module--selectIconColor--64cdf";
export var selectItem = "Select-module--selectItem--b2f68";
export var selectLabel = "Select-module--selectLabel--e15c1";
export var selectTrigger = "Select-module--selectTrigger--0722f";
export var selectValue = "Select-module--selectValue--0e04f";
export var selectViewport = "Select-module--selectViewport--86193";
export var tickColor = "Select-module--tickColor--6deb4";